export default __webpack_public_path__ + "static/media/pages-background.a232d1b6.png";